<template>
    <div class="hiq-public-art__item">
        <a class="hiq-public-art__item--link" :href="item.url">
            <div class="hiq-public-art__item--image" v-html="item.image" :class="imageClass"></div>
            <div class="hiq-public-art__item--info">
                <h3 class="hiq-public-art__item--title">{{item.title}}</h3>
                <p class="hiq-public-art__item--text" v-if="item.year || item.artist">
                    <strong>
                        <span class="show-for-sr">{{translations.year}}:</span>
                        {{item.year}}
                        <span class="show-for-sr">{{translations.artist}}:</span>
                        {{item.artist}}
                    </strong>
                </p>
                <p class="hiq-public-art__item--text" v-if="item.location">
                    <span class="show-for-sr">{{translations.location}}:</span>
                    {{item.location}}
                </p>
                <p class="hiq-public-art__item--text" v-if="item.description">
                    <span class="show-for-sr">{{translations.description}}:</span>
                    {{item.description}}
                </p>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: 'art-item',
    props: ['item', 'imageClass'],
    computed: {
        translations() {
            return this.$store.state.translations;
        }
    }
}
</script>